// Profile routes (portal: src/constants/routes.tsx:91-110). Registered at the
// top level of the shell routes; react-router ranks these static `profiles`
// segments above the tenant area's `tenants/*` routes. Profiles are not a
// resource and the routes are ungated, as in the portal (PARITY Q29).
import type { RouteObject, UIMatch } from 'react-router-dom'
import { lazyPages } from '../../app/lazyRoute'
import type { Crumb, CrumbHandle } from '../../shell'

const page = lazyPages('src/features/profiles/pages.tsx', () => import('./pages'))
const crumb = (text: string): CrumbHandle => ({ crumb: () => text })

/** Tenants › <tenant> › Profiles: the profile's location under its tenant (brief §3, Shell). */
function tenantTrail(match: UIMatch): Crumb[] {
  const id = match.params.id ?? ''
  const tenant = `/tenants/${encodeURIComponent(id)}`
  return [
    { pathname: '/tenants', label: 'Tenants' },
    { pathname: tenant, label: id },
    // The Profiles tab (index 1 when visible, Q24).
    { pathname: `${tenant}/1`, label: 'Profiles' }
  ]
}

export const profilesRoutes: RouteObject[] = [
  {
    path: 'tenants/:id/profiles/create',
    handle: {
      crumb: (match) => [
        ...tenantTrail(match),
        { pathname: match.pathname, label: 'Create profile' }
      ]
    } satisfies CrumbHandle,
    lazy: page('ProfileCreatePage')
  },
  {
    // The bare profile URL is the edit page; `/show` is the show page.
    path: 'tenants/:id/profiles/:profileId',
    handle: {
      crumb: (match) =>
        match.params.profileId
          ? [
              ...tenantTrail(match),
              { pathname: match.pathname, label: `Profile ${match.params.profileId}` }
            ]
          : null
    } satisfies CrumbHandle,
    children: [
      { index: true, lazy: page('ProfileEditPage') },
      { path: 'show', handle: crumb('Show'), lazy: page('ProfileShowPage') }
    ]
  }
]
